import RightModal from "../../../properties/partials/RightModal";
import { useT } from '../../../../../helpers/i18n';
import ContentWrapper from "../../../properties/partials/ContentWrapper";
import SimpleContent from "../../../properties/partials/SImpleContent";
import SwipperWrapper from "../../../properties/partials/SwipperWrapper";
import React, {useState} from "react";
import Included from "./included/Included";
import Ondemand from "./ondemand/Ondemand";
import {SwiperSlide} from "swiper/react";
import Checkers from "../../../../../helpers/class/Checkers";
import {faLink} from "@fortawesome/pro-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface SingleServiceContentPros {
    service: any
    layout: string
    useSwiper?: boolean
}

const SingleServiceContent = ({ service, layout, useSwiper = false } : SingleServiceContentPros) => {
    const t = useT();
    const [show, setShow] = useState(false);
    const [modalState, setModalState] = useState("close");

    const handleShow = (state) => {
        setShow(true);
        setModalState(state);
    }

    const handleHide = () => {
        setShow(false);
        setModalState("close");
    }

    const for_modal = {
        handleHide: handleHide,
        setModalState: setModalState
    }
    let col_class_name = '';
    let col_class_name_inner = 'service-item-design-box m-b-15 m-r-5 ';
    let service_class_name = '';
    let service_component = null;

    const has_body = true //Checkers.isValidString( service.service_body );

    switch (layout) {
        case 'list':
            col_class_name = 'col-12 col-sm-6 col-md-4 col-lg-6 px-0';
            service_class_name = 'service-item color d-flex flex-row w-100 no-margin';
            service_component = <Included service={service}/>;
            break;
        case 'grid':
        case 'carousel':
            col_class_name = 'col-6 col-sm-3 p-l-0 p-r-0';
            col_class_name_inner += 'p-0 ';
            service_class_name = 'card w-100 bg-transparent border-0 shadow-none';
            service_component = <Ondemand service={service}/>;
            break;
    }
    service_class_name += has_body ? '\ cursor-pointer' : '';

    return (
        <>
            <div className={useSwiper?"":col_class_name}>
                <div key={service.service_id.toString()} className={col_class_name_inner}>
                    <div className={useSwiper?"":service_class_name}
                         onClick={has_body ? () => handleShow('service-' + service.service_id) : undefined}>
                        {service_component}
                    </div>
                    {
                        has_body &&
                        <RightModal
                            key={100}
                            modalName={'service-' + service.service_id}
                            className="slide_right"
                            Title={service.service_title}
                            modalSize="lg"
                            loaderStatus={false}
                            closeModal={() => {
                                handleHide()
                            }}
                            show={modalState === 'service-' + service.service_id}
                            BodyRender={<ContentWrapper ContentRender={
                                <>
                                    <SimpleContent
                                        content={(Checkers.isValidPositiveNumber(service.schedule_cycle_value) ? service.schedule_cycle_value + " " : '') + service.schedule_cycle_label}/>
                                    <SwipperWrapper key="single-service-images-swiper" images={service.service_images}
                                                    galleryHeight={'285px'}
                                                    imageKey={'service_image'} enableFancyBox={false}/>
                                    <SimpleContent content={service.service_body}/>
                                    {
                                        Checkers.isValidString(service.addon_url) ?
                                            <>
                                                <a className={'btn btn-primary btn-design-color btn-lg p-r-15 p-l-15'} href={service.addon_url} target={'_blank'} rel="noreferrer">
                                                    <FontAwesomeIcon icon={faLink} size="1x"/>&nbsp;{t('services.link')}
                                                </a>
                                            </>
                                            :
                                            <>
                                            </>
                                    }
                                </>
                            }/>}
                        />
                    }
                </div>
            </div>
        </>
    )
}

export default SingleServiceContent